<script>
import kendo from '@progress/kendo-ui/js/kendo.all.js'
export default {
  props: ['height', 'filters'],
  data: () => ({
    fieldName: '',
    fieldLabel: '',
    gridRef: ''
  }),
  watch: {
    // whenever question changes, this function will run
    filters: {
      deep: true,
      handler: function(newFilters) {
        try {
          let lines = kendo.jQuery(this.$refs[this.gridRef].$el).find('tbody tr')
          let grid = this.$refs[this.gridRef].getGrid()
          this.highlight(lines, grid, newFilters)
        } catch (err) {}
      }
    }
  },
  methods: {
    dataBound(e) {
      var lines = e.sender.table.find('tbody tr')
      var grid = e.sender.table.parents('.k-grid:first').data('kendoGrid')
      this.highlight(lines, grid, this.filters)
    },
    highlight(lines, grid, activeFilters) {
      for (let i = 0; i < lines.length; i++) {
        let selectedRow = grid.dataItem(lines[i])
        let itemId = selectedRow.id
        let exists = this.filterActive(itemId, activeFilters)
        if (exists > 0) {
          kendo.jQuery(lines[i]).addClass('table-success')
        } else if (exists < 0) {
          kendo.jQuery(lines[i]).addClass('table-danger')
        } else {
          kendo.jQuery(lines[i]).removeClass('table-danger table-success')
        }
      }
    },
    addIncludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs[this.gridRef].$refs.mygrid.kendoWidget()
      var row = kendo.jQuery(e.currentTarget).closest('tr')
      var dataItem = grid.dataItem(row)
      row.removeClass('table-danger').addClass('table-success')
      this.$emit('added-filter', {
        field: this.fieldName,
        item: dataItem,
        title: this.fieldLabel,
        'type': 'includes'
      })
    },
    filterActive(itemId, activeFilters) {
      for (var c = 0; c < activeFilters.length; c++) {
        if (activeFilters[c].field === this.fieldName) {
          for (let w = 0; w < activeFilters[c].includes.length; w++) {
            if (activeFilters[c].includes[w].id === itemId) {
              return 1
            }
          }
          for (let w = 0; w < activeFilters[c].excludes.length; w++) {
            if (activeFilters[c].excludes[w].id === itemId) {
              return -1
            }
          }
          return 0
        }
      }
      return 0
    },
    addExcludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs[this.gridRef].$refs.mygrid.kendoWidget()
      var row = kendo.jQuery(e.currentTarget).closest('tr')
      var dataItem = grid.dataItem(row)
      row.removeClass('table-success').addClass('table-danger')
      this.$emit('added-filter', {
        field: this.fieldName,
        item: dataItem,
        title: this.fieldLabel,
        'type': 'excludes'
      })
    },
    addAll() {
      var grid = this.$refs[this.gridRef].$refs.mygrid.kendoWidget()
      let opts = grid.getOptions()
      this.axios.post(this.url + '/all', {filter: opts.dataSource.filter}).then(response => {
        for (var i = 0; i < response.data.data.length; i++) {
          this.$emit('added-filter', {
            field: this.fieldName,
            item: response.data.data[i],
            title: this.fieldLabel,
            'type': 'includes'
          })
        }
      })
    },
    excludeAll() {
      var grid = this.$refs[this.gridRef].$refs.mygrid.kendoWidget()
      let opts = grid.getOptions()
      this.axios.post(this.url + '/all', {filter: opts.dataSource.filter}).then(response => {
        for (var i = 0; i < response.data.data.length; i++) {
          this.$emit('added-filter', {
            field: this.fieldName,
            item: response.data.data[i],
            title: this.fieldLabel,
            'type': 'excludes'
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// BaseFilter.vue?72ceb582